// Adapted from shadcn/ui's React 18 registry button (MIT):
// https://ui.shadcn.com/r/styles/new-york/button.json
import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "../../lib/utils";

export const buttonVariants = cva("vl-button", {
  variants: {
    variant: {
      default: "vl-button-primary",
      outline: "vl-button-outline",
      ghost: "vl-button-ghost",
      destructive: "vl-button-destructive",
    },
    size: { default: "vl-button-default", sm: "vl-button-sm" },
  },
  defaultVariants: { variant: "default", size: "default" },
});
export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean;
}
export const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, type, ...props }, ref) => {
    const Component = asChild ? Slot : "button";
    return (
      <Component
        ref={ref}
        type={asChild ? undefined : type || "button"}
        className={cn(buttonVariants({ variant, size }), className)}
        {...props}
      />
    );
  },
);
Button.displayName = "Button";
